<template>
  <div id="DepositPayPage" class="deposit-pay-page">
    <div class="deposit-pay-shell">
    <loading v-if="loadingRender"></loading>
    <panel
      Title="واریز بدون ورود"
      Des="با شناسه واریز، شماره حساب یا کد ملی، بدون ورود به سامانه پرداخت کنید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <net-pa-card class="deposit-pay-card">
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-money-check-alt ml-2"></i>
          واریز به حساب / پرداخت اقساط
        </h6>
      </template>
      <template slot="content">
        <form id="div1" class="deposit-pay-form" @submit.prevent>
          <div class="deposit-pay-layout">
            <div class="deposit-pay-main">
              <div class="deposit-pay-methods" v-if="!IsQuery" role="radiogroup" aria-label="روش واریز">
                <button
                  type="button"
                  class="deposit-pay-method"
                  :class="{ 'is-active': DepositType == 1 }"
                  @click="getDepositType(1)"
                >
                  شناسه واریز
                </button>
                <button
                  type="button"
                  class="deposit-pay-method"
                  :class="{ 'is-active': DepositType == 2 }"
                  @click="getDepositType(2)"
                >
                  شماره حساب
                </button>
                <button
                  type="button"
                  class="deposit-pay-method"
                  :class="{ 'is-active': DepositType == 3 }"
                  @click="getDepositType(3)"
                >
                  کد ملی / مشتری
                </button>
              </div>

              <div v-if="DepositType == 1 && !IsQuery" class="deposit-pay-lookup">
                <input
                  autocomplete="off"
                  class="form-control deposit-pay-input text-center"
                  id="Shenase"
                  type="number"
                  placeholder="شناسه واریز"
                  v-model="Shenase"
                  v-mask="'####################'"
                />
                <button type="button" class="deposit-pay-check" @click="CheckupShenase()">
                  بررسی
                </button>
              </div>
              <div v-if="DepositType == 2" class="deposit-pay-lookup">
                <input
                  autocomplete="off"
                  class="form-control deposit-pay-input text-center"
                  dir="ltr"
                  id="VCode"
                  type="text"
                  placeholder="شماره حساب | تسهیلات"
                  v-model="VCode"
                  v-mask="'###-##-##########'"
                />
                <button type="button" class="deposit-pay-check" @click="CheckupVcode()">
                  بررسی
                </button>
              </div>
              <div v-if="DepositType == 3" class="deposit-pay-lookup">
                <input
                  autocomplete="off"
                  class="form-control deposit-pay-input text-center"
                  dir="ltr"
                  id="ShenaseOzve"
                  type="text"
                  placeholder="شماره مشتری / کدملی"
                  v-model="ShenaseOzv"
                  v-mask="'##########'"
                />
                <button type="button" class="deposit-pay-check" @click="CheckupShenaseOzve()">
                  بررسی
                </button>
              </div>

              <select
                v-if="DepositType == 3 && IsLoad"
                class="form-control deposit-pay-input text-center Pointer"
                id="SelectNoeVarizi"
                @change="Resultradio3()"
                v-model="Resultcmb"
              >
                <option :value="-1">-- انتخاب حساب | تسهیلات --</option>
                <option v-for="item in this.ListModel" :key="item.id" :value="item">
                  <span>{{ item.vCode }}</span> <span>{{ item.desNoe }}</span>
                </option>
              </select>

              <div v-if="Result != null" class="deposit-pay-result">
                <span>{{ Result.nameFamily }}</span>
                <span>{{ Result.desNoe }}</span>
                <span v-if="Result.tblSarfaslTypeId == 1" class="deposit-pay-result__due">
                  سررسید {{ Result.minTarGhestBedehkar }}
                </span>
              </div>

              <input
                v-if="DepositType == 2 || DepositType == 1 || DepositType == 3"
                class="form-control deposit-pay-input deposit-pay-amount text-center 3ragham"
                id="Mab"
                :disabled="FixVariz"
                v-model="Mablagh"
                dir="rtl"
                @keyup="$PutCommatoInput()"
                @keypress="$ValidNumber($event, 11)"
                type="text"
                placeholder="مبلغ واریزی"
              />

              <div class="deposit-pay-payer">
                <input
                  class="form-control deposit-pay-input text-center required"
                  type="text"
                  @keypress="$ValidPersian($event,100)"
                  placeholder="نام و نام خانوادگی"
                  :value="NameFamily"
                  @input="onNameFamilyInputNoQuotes"
                />
                <input
                  class="form-control deposit-pay-input text-center required"
                  dir="ltr"
                  type="number"
                  @keypress="$ValidNumber($event, 11)"
                  placeholder="شماره تلفن"
                  v-model="Mobile"
                />
              </div>
              <textarea
                class="form-control deposit-pay-input deposit-pay-notes text-center"
                placeholder="توضیحات"
                maxlength="300"
                rows="2"
                v-model="Description"
              ></textarea>
            </div>

            <aside class="deposit-pay-checkout">
              <payment
                v-if="wwwtblShobeid != null"
                @GatewayCode="Get_GatewayCode"
                @FixVarizGhestHasJarime="FixVarizGhestHasJarime"
                @FixVarizGhest="FixVarizGhest"
                :wwwtblShobeid="wwwtblShobeid"
              >
                <template v-slot:ContentButtonPayment>
                  <button
                    id="BtnPayment"
                    class="btn deposit-pay-submit"
                    :class="Result == null || Number(Mablagh.replace(/,/g, '')) < 10000 ? 'btn-secondary' : 'btn-success'"
                    :disabled="Result == null || Number(Mablagh.replace(/,/g, '')) < 10000"
                    @click.prevent="Payment"
                  >
                    واریز
                    {{ $Comma3ragham(Mablagh.replace(/,/g, '')) }}
                  </button>
                  <div id="AletSumMab" class="alert alert-info w-100 font-weight-bold d-none">
                    تسهیلات انتخابی شما تسویه شده ،برای اطمینان بیشتر از داخل پنل کاربری خود در سامانه از بخش لیست تسهیلات وضعیت تسهیلات خودرا مشاهده کنید
                  </div>
                </template>
              </payment>
              <p v-else class="deposit-pay-hint">
                روش واریز را انتخاب کنید و پس از بررسی، درگاه نمایش داده می‌شود.
              </p>
            </aside>
          </div>
        </form>
      </template>
    </net-pa-card>
    </div>
  </div>
</template>
<script>
import Panel from '../Tools/NetPa/Panel.vue'
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import Payment from './Payment.vue'
import loading from '../Tools/NetPa/Loading.vue'
export default {
  components: {
    Panel,
    NetPaCard,
    Payment,
    loading,
  },
  data() {
    return {
      DataAxios_cmbTaahodat: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TaahodatByShenasNew',
        Token: '',
      },
      Resultcmb: -1,
      ShenaseOzv: null,
      ListModel: null,
      IsLoad: false,
      DepositType: 1,
      Shenase: '',
      VCode: '',
      Mablagh: '',
      NameFamily: '',
      Mobile: '',
      Description: '',
      Result: null,
      GatewayCode: null,
      DataAxiosRow: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TaahodatByShenaseVarizNew',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxiosRowVCode: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TaahodatByVCNew',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_Variz: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'VarizGorohi/SetVarizGorohi',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxiosRowGetShenase: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat/GetShenaseVariz',
        Token: this.$session.get('TokenNetPa'),
      },
      FixVariz: false,
      loadingRender: false,
      MabFormulaJarime: 0,
      CheckUpMablagh: null,
      IsQuery: false,
      IsLinkPay: false,
      wwwtblShobeid:null
    }
  },
  methods: {
    onNameFamilyInputNoQuotes(e) {
      this.NameFamily = (e.target.value || '').replace(/['"]/g, '')
    },
    CheckupShenaseOzve() {
      if (this.ShenaseOzv != '') {
        this.loadingRender = true
        const formData = new FormData()
        // var convertShenase=this.ShenaseOzv.toString().substring(0,this.ShenaseOzv.toString().length-2)
        formData.append('Shenase', this.$Encryption(this.ShenaseOzv))
        this.DataAxios_cmbTaahodat.ArryfildValue = formData
        this.$PostFormData(this.DataAxios_cmbTaahodat).then((data) => {
          if (data.length != 0) {
            // console.log(data);
            this.IsLoad = true
            if (this.$session.get('CustCode') == 255) {
              this.ListModel = data.filter((x) => x.tblsarfasltypeid != 6)
            } else {
              this.ListModel = data
            }
            this.loadingRender = false
          } else {
            this.$mySweetDefaultTost('خطا', 'شناسه مشتری وارد شده صحیح نمی باشد .', 'error', 2500)
            this.loadingRender = false
          }
          // this.Resultcmb = data[0]
        })
      } else {
        this.$mySweetDefault('خطا', 'شناسه مشتری نمی تواند خالی می باشد ', 'error', 2500)
      }
    },
    getDepositType(val) {
      this.DepositType = val
      this.Result = null
      // if(val==3){

      // }
    },
    gotonoti() {
      const notification = {
        title: 'تیکت جدید',
        options: {
          body: 'خطا در نرم افزار .....',
          icon: './img/icons/favicon.ico',
          silent: true,
        },
        events: {
          onerror: function () {},
          onclick: function () {
            alert('ok')
          },
          onclose: function () {},
          onshow: function () {},
        },
      }
      this.$notification.show(notification.title, notification.options, notification.events)
    },
    CheckupShenase() {
      if (this.Shenase != '') {
        this.loadingRender = true
        this.VCode = ''
        const formData = new FormData()
        formData.append('ShenaseVariz', this.$Encryption(this.Shenase))
        this.DataAxiosRow.ArryfildValue = formData

        this.$PostFormData(this.DataAxiosRow).then((data) => {
          if (data.state == 'Success') {
            this.loadingRender = false
            this.Result = data.result
            this.wwwtblShobeid=this.Result.wwwtblShobeid
            if (data.result.tblSarfaslTypeId != 1) {
              this.FixVariz = false
            }
            if (data.result.mande + data.result.wwwJarime - data.result.sumMabTaeedNaShode <= 0 && data.result.tblSarfaslTypeId == 1) {
              document.getElementById('Mab').classList.add('d-none')
              document.getElementById('BtnPayment').classList.add('d-none')

              document.getElementById('AletSumMab').classList.remove('d-none')
            } else {
              document.getElementById('Mab').classList.remove('d-none')
              document.getElementById('BtnPayment').classList.remove('d-none')

              document.getElementById('AletSumMab').classList.add('d-none')
            }

            if (data.result.mablaghGhestVam > 0) {
              this.Mablagh = this.$Comma3ragham(data.result.sumGhabelPar)
              this.CheckUpMablagh = data.result.sumGhabelPar
            } else {
              this.Mablagh = ''
            }
            this.loadingRender = false
          } else {
            if (this.$route.query.sh) {
              if (Number(this.$route.query.sh) > 0 && this.$route.query.sh != null) {
                this.$mySweetDefaultTost('خطا', 'شناسه واریز موجود در لینک صحیح نمیباشد.', 'error', 5000)
                this.$router.push({ name: 'LoginPage' })
              }
            } else this.$mySweetDefaultTost('خطا', 'شناسه وارد شده صحیح نمی باشد .', 'error', 2500)
            this.Result = null
            this.loadingRender = false
          }
        })
      } else {
        this.$mySweetDefault('خطا', 'شناسه واریز خالی می باشد ', 'error', 2500)
        this.Result = null
      }
    },
    CheckupVcode() {
      if (this.VCode != '') {
        this.loadingRender = true
        this.Shenase = ''
        const formData = new FormData()
        formData.append('VCode', this.$Encryption(this.VCode))
        this.DataAxiosRowVCode.ArryfildValue = formData

        this.$PostFormData(this.DataAxiosRowVCode).then((data) => {
          if (data != null) {
            this.Result = data
            this.loadingRender = false
            this.wwwtblShobeid=this.Result.wwwtblShobeid
            //console.log('😎 ~ this.$PostFormData ~ data:', data)
            if (data.mande + data.wwwJarime - data.sumMabTaeedNaShode <= 0 && data.tblSarfaslTypeId == 1) {
              document.getElementById('Mab').classList.add('d-none')
              document.getElementById('BtnPayment').classList.add('d-none')

              document.getElementById('AletSumMab').classList.remove('d-none')
            } else {
              document.getElementById('Mab').classList.remove('d-none')
              document.getElementById('BtnPayment').classList.remove('d-none')

              document.getElementById('AletSumMab').classList.add('d-none')
            }
            if (data.sumGhabelPar > 0) {
              this.Mablagh = this.$Comma3ragham(data.sumGhabelPar)
            }
            if (data.mablaghGhestVam > 0) {
              this.Mablagh = this.$Comma3ragham(data.sumGhabelPar)
              this.CheckUpMablagh = data.sumGhabelPar
            }
            // else {
            //   this.Mablagh = ''
            // }
          } else {
            this.$mySweetDefaultTost('خطا', 'شماره حساب وارد شده صحیح نمی باشد .', 'error', 2500)
            this.Result = null
            this.loadingRender = false
          }
        })
      } else {
        this.$mySweetDefault('خطا', 'شماره حساب نمی تواند خالی می باشد ', 'error', 2500)
        this.Result = null
      }
    },
    CheckupVcodeByShenase(vcode) {
      if (vcode != '') {
        this.loadingRender = true
        this.Shenase = ''
        const formData = new FormData()
        formData.append('VCode', this.$Encryption(vcode))
        this.DataAxiosRowVCode.ArryfildValue = formData

        this.$PostFormData(this.DataAxiosRowVCode).then((data) => {
          // console.log("😂 ~ data:", data)
          if (data != null) {
            this.loadingRender = false
            this.wwwtblShobeid=data.wwwtblShobeid
            // console.log('*/*/*/*/',data);
            this.Result = data
            if (data.mande + data.wwwJarime - data.sumMabTaeedNaShode <= 0 && data.tblSarfaslTypeId == 1) {
              document.getElementById('Mab').classList.add('d-none')
              document.getElementById('BtnPayment').classList.add('d-none')

              document.getElementById('AletSumMab').classList.remove('d-none')
            } else {
              document.getElementById('Mab').classList.remove('d-none')
              document.getElementById('BtnPayment').classList.remove('d-none')

              document.getElementById('AletSumMab').classList.add('d-none')
            }
            if (data.mablaghGhestVam > 0) {
              this.Mablagh = this.$Comma3ragham(data.sumGhabelPar)
              this.CheckUpMablagh = data.sumGhabelPar
            } else if (data.sumGhabelPar > 0) {
              this.Mablagh = this.$Comma3ragham(data.sumGhabelPar)
              this.CheckUpMablagh = data.sumGhabelPar
            } else {
              this.Mablagh = ''
            }
            this.loadingRender = false
          } else {
            this.$mySweetDefaultTost('خطا', 'شماره حساب وارد شده صحیح نمی باشد .', 'error', 2500)
            this.Result = null
            this.loadingRender = false
          }
        })
      } else {
        this.$mySweetDefault('خطا', 'شماره حساب نمی تواند خالی می باشد ', 'error', 2500)
        this.Result = null
      }
    },
    Payment() {
      if (this.$ValidForm('div1')) {
        if (this.Result.tblSarfaslTypeId != 1) {
          this.SendPayment()
        } else {
          if (this.Result.sumGhabelPar || this.Result.sumGhabelPar != null) {
            if (Number(this.Mablagh.replace(/,/g, '')) > this.Result.mande + this.Result.wwwJarime - this.Result.sumMabTaeedNaShode) {
              this.$mySweetDefault('هشدار', 'مبلغ پرداختی نمی تواند بیشتر از مانده تسهیلات باشد . ', 'warning', 2500)
            } else {
              this.FormulaJarime()
            }
          } else {
            this.$mySweetDefault('خطا', 'تسهیلات انتخابی شما تسویه شده ،برای اطمینان بیشتر از داخل پنل کاربری خود در سامانه از بخش لیست تسهیلات وضعیت تسهیلات خودرا مشاهده کنید', 'error', 2500)
          }
        }
      }
    },
    Get_GatewayCode(val) {
      this.GatewayCode = val
    },
    GetShenase(Vcode) {
      const formData = new FormData()
      formData.append('Vcode', Vcode)
      this.DataAxiosRowGetShenase.ArryfildValue = formData
      this.$PostFormData(this.DataAxiosRowGetShenase).then((data) => {
        return data
      })
    },
    Resultradio3() {
      // console.log(this.Resultcmb);
      if (this.Resultcmb != -1) {
        this.CheckupVcodeByShenase(this.Resultcmb.vCode)
      }
    },
    FixVarizGhest(val) {
      this.FixVariz = val
      if (this.Result.tblSarfaslTypeId != 1 && this.Result.sumGhabelPar == 0) {
        this.FixVariz = false
      }
    },
    FixVarizGhestHasJarime(val) {
      var jarime=this.Result.wwwJarime
      if (jarime>0 ) {
        this.FixVariz = val
      }
    },
    SendPayment() {

      this.Mablagh = this.Mablagh.replace(/,/g, '')
      const WwwtblVarizGorohiRiz = []
      WwwtblVarizGorohiRiz.push({
        WwwtblTaahodatId: this.Result.id,
        Mablagh: Number(this.Mablagh.replace(/,/g, '')),
        SharhRiz: this.Description + this.Result.vCode,
        WwwtblAzaId: this.Result.wwwtblAzaId,
        BnpCashDBtblTaahodatId: this.Result.bnpCashDBtblTaahodatId,
        BnpCashDBtblAzaId: this.Result.bnpCashDBtblAzaId,
        MablaghJarime: Math.floor(this.MabFormulaJarime),
        TarixGhest: this.Result.minTarGhestBedehkar,
        IsTaahodatRiz: false,
      })

      this.DataAxios_Variz.ArryfildValue.Mablagh = Number(this.Mablagh.replace(/,/g, ''))
      this.DataAxios_Variz.ArryfildValue.CodeRahgiri = 0
      this.DataAxios_Variz.ArryfildValue.Tarix = this.$store.state.JalaliDate
      this.DataAxios_Variz.ArryfildValue.Sharh = ' واریز | پرداخت بدون ورود '
      this.DataAxios_Variz.ArryfildValue.ZamanInsert = this.$store.state.JalaliDate
      this.DataAxios_Variz.ArryfildValue.CustCode = Number(this.$session.get('CustCode'))
      this.DataAxios_Variz.ArryfildValue.tblComboIdVaziatGrp312 = 5538
      this.DataAxios_Variz.ArryfildValue.wwwtblAzaId = Number(this.Result.wwwtblAzaId)
      this.DataAxios_Variz.ArryfildValue.StatusVariz = 2
      this.DataAxios_Variz.ArryfildValue.WwwtblVarizGorohiRiz = WwwtblVarizGorohiRiz
      this.$PostData(this.DataAxios_Variz).then((result) => {
        if (result.status === 'Success') {
          this.$Payment(
            this.GatewayCode + '',
            this.Mablagh,
            this.NameFamily,
            '',
            this.Mobile,
            WwwtblVarizGorohiRiz[0].WwwtblTaahodatId,
            this.Shenase != null && this.Result != null ? this.Shenase + '' : this.GetShenase(this.VCode),
            this.Result.vCode,
            'واریز | پرداخت  بدون ورود',
            this.Result.wwwtblAzaId + '',
            this.$session.get('CustCode'),
            this.Result.wwwtblShobeid + '',
            result.idRepoMaster,
            this.Result.codeMeli.trim(),
            this.Result.nameFamily,
            this.Result.mobile,
            this.Result.codeMeli.trim(),
          )
        } else {
          this.$mySweetDefaultTost(' ', ' در پرداخت مشکلی پیش آمده لطفا مجددا تلاش فرمایید', 'warning', 4000)
          this.DeleteAllItemsCart()
        }
      })
    },
    FormulaJarime() {
      if (Number(this.Mablagh.replaceAll(/,/g, '')) < Number(this.CheckUpMablagh)) {
        var MablaghJarime = this.Result.wwwJarime == null ? 0 : this.Result.wwwJarime
        if (this.$session.get('CustCode') == 561){
          this.MabFormulaJarime = (Number(this.Mablagh.replaceAll(/,/g, '')) / (Number(this.CheckUpMablagh))) * MablaghJarime
        }
        else{
          this.MabFormulaJarime = (Number(this.Mablagh.replaceAll(/,/g, '')) / (Number(this.CheckUpMablagh) - MablaghJarime)) * MablaghJarime
        }
        this.SendPayment()
      } else {
        this.MabFormulaJarime = this.Result.wwwJarime == null ? 0 : this.Result.wwwJarime
        this.SendPayment()
      }
    },
    CheckupLinkPay() {
      if (this.$route.query.sh) {
        if (Number(this.$route.query.sh) > 0 && this.$route.query.sh != null) {
          if (this.IsLinkPay) {
            this.loadingRender = true
            this.IsQuery = true
            this.Shenase = Number(this.$route.query.sh)
            this.CheckupShenase()
          } else {
            this.$mySweetDefaultTost('خطا', 'سامانه واریز با لینک پرداخت برای شما فعال نگریدیده ، لطفا با مدیریت '+this.$session.get('IsTaavoniEtebar')==true?'تعاونی اعتبار':'صندوق'+' هماهنگ کنید', 'error', 8000)
            this.loadingRender = true
          }
        } else {
          this.IsQuery = false
        }
      } else {
        this.IsQuery = false
      }
    },
  },
  // updated() {
  //   if (document.getElementById("SelectNoeVarizi") === document.activeElement) {
  //     if (this.DepositType == 1) {
  //       document.getElementById("Shenase").focus();
  //     }
  //     if (this.DepositType == 2) {
  //       document.getElementById("VCode").focus();
  //     }
  //   }
  // },
  mounted() {
    document.documentElement.classList.add('deposit-pay-html')
    document.body.classList.add('deposit-pay-html')
    if (!this.$session.get('CustCode')) {
      console.warn('MOUNTES')
      this.$router.push({ name: 'LoginPage' })
    }
  },
  beforeDestroy() {
    document.documentElement.classList.remove('deposit-pay-html')
    document.body.classList.remove('deposit-pay-html')
  },
  created() {
    var axios = require('axios')
    var config = {
      method: 'GET',
      url: '/appSettings.json?nocache=123',
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
      },
    }
    axios(config).then((result) => {
      // console.log(result.data)
      this.IsLinkPay = this.$GetIsLinkPay()
      this.CheckupLinkPay()
    })
  },
  
}
</script>
<style scoped>
.deposit-pay-page {
  min-height: 100vh;
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 12px 16px 28px;
  box-sizing: border-box;
  background: #f5f7fb !important;
}

.deposit-pay-shell {
  width: 100%;
  max-width: 560px;
  margin-left: auto;
  margin-right: auto;
}

.deposit-pay-form {
  width: 100%;
}

.deposit-pay-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 12px;
  align-items: start;
}

.deposit-pay-main,
.deposit-pay-checkout {
  min-width: 0;
}

.deposit-pay-main {
  display: grid;
  gap: 8px;
}

.deposit-pay-methods {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
}

.deposit-pay-method {
  min-height: 36px;
  padding: 6px 8px;
  color: #29345f;
  border: 1px solid #dbe5eb;
  border-radius: 10px;
  background: #fff;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.3;
  cursor: pointer;
}

.deposit-pay-method.is-active {
  color: #068997;
  border-color: rgba(5, 184, 200, 0.35);
  background: #e9f9fb;
}

.deposit-pay-lookup {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 6px;
}

.deposit-pay-input {
  min-height: 40px;
  padding: 0.45rem 0.7rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  border: 1px solid #dbe5eb;
  border-radius: 10px;
  background: #fff;
}

.deposit-pay-amount {
  font-size: 18px !important;
  font-weight: 800;
}

.deposit-pay-check {
  min-width: 72px;
  min-height: 40px;
  padding: 0 12px;
  color: #068997;
  border: 1px solid rgba(5, 184, 200, 0.28);
  border-radius: 10px;
  background: #e9f9fb;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.deposit-pay-result {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 10px;
  padding: 8px 10px;
  color: #29345f;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.5;
  border: 1px solid #e8eef2;
  border-radius: 10px;
  background: #fff;
}

.deposit-pay-result__due {
  color: #b44f46;
}

.deposit-pay-payer {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
}

.deposit-pay-notes {
  min-height: 64px;
  resize: vertical;
}

.deposit-pay-checkout {
  padding: 10px;
  border: 1px solid #e8eef2;
  border-radius: 14px;
  background: #fff;
}

.deposit-pay-hint {
  margin: 0;
  color: #6b7b8e;
  font-size: 12px;
  line-height: 1.7;
  text-align: right;
}

.deposit-pay-submit {
  width: 100%;
  min-height: 42px;
  border-radius: 12px;
  font-weight: 700;
}

@media (min-width: 420px) {
  .deposit-pay-payer {
    grid-template-columns: minmax(0, 1.1fr) minmax(0, 0.9fr);
  }
}

@media (max-width: 575px) {
  .deposit-pay-method {
    padding: 6px 4px;
    font-size: 11px;
  }

  .deposit-pay-notes {
    min-height: 52px;
  }
}
</style>
<style>
html.deposit-pay-html,
body.deposit-pay-html,
body.deposit-pay-html #app,
html.deposit-pay-html body,
#DepositPayPage.deposit-pay-page,
#DepositPayPage {
  background: #f5f7fb !important;
  background-color: #f5f7fb !important;
  background-image: none !important;
}

#DepositPayPage .deposit-pay-card.netpa-card,
#DepositPayPage .deposit-pay-card {
  height: auto !important;
  background: #fff !important;
}

#DepositPayPage .netpa-card__header,
#DepositPayPage .netpa-card__body {
  background: #fff !important;
}

@media (max-width: 767px) {
  #DepositPayPage .netpa-card__header {
    min-height: 48px;
    padding: 10px 12px !important;
  }

  #DepositPayPage .netpa-card__body {
    padding: 10px !important;
  }

  #DepositPayPage .netpa-page-panel {
    margin-bottom: 8px;
  }

  #DepositPayPage .border-bottom.border-warning,
  #DepositPayPage .alert {
    margin-bottom: 8px;
  }
}
</style>
